import { gql } from "@apollo/client";

export const updateEngagementStatus = gql`
  mutation UpdateEngagementStatus(
    $id: ID!
    $programId: String!
    $adminId: String!
    $status: String!
    $reason: String
    $points: Int
  ) {
    updateEngagementStatus(
      id: $id
      programId: $programId
      adminId: $adminId
      status: $status
      reason: $reason
      points: $points
    ) {
      id
      profileId
      profileEmail
      profilePhone
      profileLogin
      engagementType
      deviceId
      campaignName
      performanceDate
      identifier
      productSkus
      programPoints
      campaignPoints
      status
      image
      vendorName
      outcomes {
        outcome
        value
      }
      metadata {
        packageData
        receiptData
      }
    }
  }
`;
